var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7539 11C20.1336 11 20.4474 11.2822 20.497 11.6482L20.5039 11.75V18.7509C20.5039 20.4839 19.1474 21.9001 17.4383 21.9957L17.2539 22.0009H6.25391C4.52088 22.0009 3.10467 20.6444 3.00906 18.9353L3.00391 18.7509L3.00391 11.75C3.00391 11.3358 3.3397 11 3.75391 11C4.13361 11 4.44741 11.2822 4.49707 11.6482L4.50391 11.75V18.7509C4.50391 19.669 5.21102 20.4221 6.11039 20.4951L6.25391 20.5009H17.2539C18.1721 20.5009 18.9251 19.7938 18.9981 18.8944L19.0039 18.7509V11.75C19.0039 11.3358 19.3397 11 19.7539 11ZM6.21931 7.2163L11.2155 2.21969C11.4816 1.95356 11.898 1.9292 12.1916 2.14672L12.2758 2.21923L17.2806 7.21585C17.5738 7.5085 17.5742 7.98337 17.2815 8.27651C17.0155 8.54299 16.5988 8.56754 16.305 8.34993L16.2208 8.27738L12.4979 4.561L12.4988 16.2549C12.4988 16.6346 12.2166 16.9484 11.8506 16.9981L11.7488 17.0049C11.3691 17.0049 11.0553 16.7228 11.0056 16.3567L10.9988 16.2549L10.9979 4.558L7.28001 8.27692C7.01375 8.5432 6.59709 8.56742 6.30347 8.34958L6.21935 8.27696C5.95307 8.01071 5.92885 7.59404 6.1467 7.30042L6.21931 7.2163Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIos);
export default __webpack_public_path__ + "static/media/share-ios.14b8a2ae9704920f0def64afb508367e.svg";
export { ForwardRef as ReactComponent };